module.exports = __webpack_public_path__ + "static/media/Screenshot_5-thumb.8fea7261.png";